import { useState } from 'react';

import { urlToBase64 } from '../../services/files';

function isImageData(imageData) {
  return (imageData || '').startsWith('data:');
}

export function useImageEditor(imageUrl, imageEditorRef) {
  const [isInitialized, setIsInitialized] = useState(false);
  const [imageEditorUrl, setImageEditorUrl] = useState(imageUrl);

  async function getImageFromImageEditor(options) {
    if (imageEditorRef.current) {
      return imageEditorRef.current.getImage(options);
    }
    return null;
  }

  async function getCurrentImage(options) {
    return isInitialized ? getImageFromImageEditor(options) : imageEditorUrl;
  }

  function initialize() {
    setIsInitialized(async (prevIsInitialized) => {
      if (!prevIsInitialized) {
        const latestImage = await getImageFromImageEditor();
        setImageEditorUrl(latestImage);
      }
      return true;
    });
  }

  async function getTouched() {
    const currentImage = await getCurrentImage();

    // If the current image is not a data URL, it has not been touched
    if (!isImageData(currentImage)) {
      return false;
    }

    // If the original imageUrl is already a data URL, compare directly
    if (isImageData(imageUrl)) {
      return currentImage !== imageUrl;
    }

    // If the original is a URL, convert it to data URL for comparison
    try {
      const baselineDataUrl = await urlToBase64(imageUrl);
      return currentImage !== baselineDataUrl;
    } catch (error) {
      return isImageData(currentImage);
    }
  }

  return {
    getCurrentImage,
    initialize,
    getTouched,
  };
}
